document.addEventListener('DOMContentLoaded', function() {
  // 要素が存在するか確認してから処理を開始
  const container = document.querySelector('.customer_voice_container');
  if (!container) return; // 要素がなければ処理中止
  
  const items = document.querySelectorAll('.customer_voice_item');
  const prevBtn = document.querySelector('.prev_btn');
  const nextBtn = document.querySelector('.next_btn');
  const dotsContainer = document.querySelector('.customer_voice_dots');
  
  // 要素が存在するか再確認
  if (!items.length || !prevBtn || !nextBtn || !dotsContainer) return;
  
  let currentIndex = 0;
  const totalItems = items.length;
  
  // カルーセルの初期化（スタイルも設定）
  function initCarousel() {
    // コンテナとアイテムの幅を明示的に設定
    container.style.width = `${totalItems * 100}%`;
    items.forEach(item => {
      item.style.width = `${100 / totalItems}%`;
    });
    
    // 初期位置設定
    container.style.transform = 'translateX(0)';
  }
  
  // ドットナビゲーションを作成
  for (let i = 0; i < totalItems; i++) {
    const dot = document.createElement('div');
    dot.classList.add('dot');
    if (i === 0) dot.classList.add('active');
    dot.addEventListener('click', () => {
      goToSlide(i);
    });
    dotsContainer.appendChild(dot);
  }
  
  // スライドを移動する関数
  function goToSlide(index) {
    if (index < 0) {
      currentIndex = totalItems - 1;
    } else if (index >= totalItems) {
      currentIndex = 0;
    } else {
      currentIndex = index;
    }
    
    container.style.transform = `translateX(-${currentIndex * (100 / totalItems)}%)`;
    
    // アクティブなドットを更新
    document.querySelectorAll('.dot').forEach((dot, i) => {
      dot.classList.toggle('active', i === currentIndex);
    });
  }
  
  // 前後のボタンイベント
  prevBtn.addEventListener('click', () => {
    goToSlide(currentIndex - 1);
  });
  
  nextBtn.addEventListener('click', () => {
    goToSlide(currentIndex + 1);
  });
  
  // カルーセルの初期化
  initCarousel();
  
  // ウィンドウリサイズ時にカルーセルを再初期化
  window.addEventListener('resize', () => {
    initCarousel();
    goToSlide(currentIndex);
  });
  
  // 自動スライド
  let autoSlide = setInterval(() => {
    goToSlide(currentIndex + 1);
  }, 5000);
  
  // ユーザー操作時の処理
  container.addEventListener('mouseenter', () => {
    clearInterval(autoSlide);
  });
  
  container.addEventListener('mouseleave', () => {
    autoSlide = setInterval(() => {
      goToSlide(currentIndex + 1);
    }, 5000);
  });
});